__turbopack_context__.v({
  "mobile-btn": "SignUpButton-module-scss-module__J5Izhq__mobile-btn",
  "sign-up-button": "SignUpButton-module-scss-module__J5Izhq__sign-up-button",
});
